import { ThemeContext } from "@certn/cascadia";
import {
  ButtonGroup,
  Grid,
  GridItem,
  PrimaryButton,
  RadioCard,
  RadioGroupField,
} from "@certn/cascadia-react";
import { Field, Form, Formik, FormikHelpers } from "formik";
import { useContext, useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import { SettingsEditItem } from "../../../components/Settings/SettingsEditItem";
import { useFormSubmit } from "../../../hooks/api/useSubmit";

export function Appearance() {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded((curr) => !curr);
  const { theme, setTheme } = useContext(ThemeContext);

  const handleSubmit = useFormSubmit(
    "/internal/people/me/preferences/appearance/update/",
    {
      onSuccess: toggle,
    }
  );

  return (
    <SettingsEditItem
      setting={t("Appearance")}
      value={
        theme === "light"
          ? t("Light mode")
          : theme === "system"
            ? t("System setting")
            : t("Dark mode")
      }
      description={t("Choose a theme setting for your Certn account")}
      expanded={expanded}
      toggle={toggle}
      testID={expanded ? "appearance-cancel-link" : "appearance-edit-link"}
    >
      <Formik
        initialValues={{ mode: theme }}
        onSubmit={({ mode }, helpers) =>
          handleSubmit(
            { theme: mode.toUpperCase() },
            helpers as unknown as FormikHelpers<{ theme: string }>
          )
        }
      >
        <Form>
          <Grid width="316px">
            <GridItem>
              <Field
                name="mode"
                as={RadioGroupField}
                isRequired
                aria-label={t("Language")}
                onChange={(theme: "light" | "dark") => setTheme(theme)}
              >
                <RadioCard value="light" testID="appearance-light-radio-button">
                  <Trans>Light mode</Trans>
                </RadioCard>
                <RadioCard value="dark" testID="appearance-dark-radio-button">
                  <Trans>Dark mode</Trans>
                </RadioCard>
              </Field>
            </GridItem>
            <GridItem>
              <ButtonGroup>
                <PrimaryButton
                  type="submit"
                  size="medium"
                  testID="appearance-save-button"
                >
                  {t("Save")}
                </PrimaryButton>
              </ButtonGroup>
            </GridItem>
          </Grid>
        </Form>
      </Formik>
    </SettingsEditItem>
  );
}
